import axiosInstance from './api';

/**
 * Fetch branding configuration from the backend API
 * This is a public endpoint that doesn't require authentication
 */
export const getBrandingConfig = async () => {
  try {
    const response = await axiosInstance.get('/branding');
    return response.data;
  } catch (error) {
    console.error('Error fetching branding configuration:', error);
    // Return default branding if API call fails
    return getDefaultBranding();
  }
};

/**
 * Default branding configuration (fallback)
 * These are generic defaults that will be replaced by backend configuration
 */
export const getDefaultBranding = () => ({
  company: {
    name: 'Company Name',
    email: 'support@company.com',
    website: 'https://company.com',
    portal_url: window.location.origin,
    support_phone: null
  },
  theme: {
    primary_color: '#1976d2',
    secondary_color: '#dc004e',
    meta_theme_color: '#1976d2'
  },
  assets: {
    logo_path: '/branding/logo.svg',
    logo_icon_path: '/branding/logo-icon.svg',
    favicon_path: '/branding/favicon.svg',
    apple_touch_icon: '/branding/apple-touch-icon.png'
  },
  meta: {
    title: 'Dashboard',
    description: 'Accounts Payable and Accounts Receivable Management System'
  },
  legal: {
    copyright_year: new Date().getFullYear(),
    copyright_holder: 'Company Name',
    about_us_url: null,
    privacy_policy_url: null,
    terms_of_service_url: null
  }
});
